import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { List } from 'antd';
import styled from 'styled-components';
import chroma from 'chroma-js';
List.Item = styled(List.Item).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['clickable', 'hoverable', 'active'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.ant-list-item {\n    border-left: ", ";\n    background-color: ", ";\n\n    ", "\n\n    ", "\n  }\n"])), function (props) {
  return props.active && "4px solid ".concat(props.theme.colors.primary);
}, function (props) {
  return props.active && chroma(props.theme.colors.grey).alpha(0.5).hex();
}, function (props) {
  return props.clickable && "\n      cursor: pointer;\n    ";
}, function (props) {
  return props.hoverable && "\n      &:hover {\n        background-color: ".concat(chroma(props.theme.colors.grey).alpha(0.35), ";\n      }\n    ");
});
export default List;